import { render, staticRenderFns } from "./Surftime.vue?vue&type=template&id=12d29d58&scoped=true&"
import script from "./Surftime.vue?vue&type=script&lang=js&"
export * from "./Surftime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d29d58",
  null
  
)

export default component.exports